import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import Hero from "../components/sections/Hero";
import AudienceRouting from "../components/sections/AudienceRouting";
import InstallationDisclosure from "../components/sections/InstallationDisclosure";
import ShowroomAnnouncement from "../components/sections/ShowroomAnnouncement";
import Showcase from "../components/sections/Showcase";
import Projects from "../components/sections/Projects";
import About from "../components/sections/About";
import Testimonials from "../components/sections/Testimonials";
import UpdatesFeed from "../components/sections/UpdatesFeed";
import BookingCTA from "../components/sections/BookingCTA";

/**
 * Home — Feb 2026 (post-move).
 *
 * Scale (Stats) and Recognition (AwardsStrip) have moved to /about per
 * client request so the homepage reads as a conversion funnel:
 *   Hero → Pathways → Disclosure → Showroom → Showcase → Projects →
 *   About teaser → Testimonials → Updates → Booking CTA.
 */
export default function Home() {
  return (
    <div data-testid="home-page" className="overflow-x-hidden">
      <Seo
        title="OPPOLIA Canada · Premium Whole-Home Cabinetry"
        description="OPPOLIA Canada delivers premium whole-home cabinetry and interior solutions for homeowners, builders, designers, and developers across Canada — from our Hamilton Experience Centre. Kitchen · Bathroom · Wardrobes · TV Panels · Doors & Windows · Furniture."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <AudienceRouting />
        <InstallationDisclosure />
        <ShowroomAnnouncement />
        <Showcase />
        <Projects />
        <About />
        <Testimonials />
        <UpdatesFeed />
        <BookingCTA />
      </main>
      <Footer />
    </div>
  );
}
